import React, {Fragment} from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";
import Select from "../../form/Select";
import OptInSubscriberFilter from "./NewsLetter/OptInSubscriberFilter";
import UserFilter from "./NewsLetter/UserFilter";
import isEqual from "lodash-es/isEqual";
import {sendRequest} from "../../../utils/request";
import parseQuery from "./NewsLetter/QueryBuilder/parseQuery";
import unparseQuery from "./NewsLetter/QueryBuilder/unparseQuery";
import removeEmpty from "./NewsLetter/QueryBuilder/removeEmpty";

class NewsletterTargetForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            sendTo: null
        }
    }

    componentDidMount() {
        this.recheck(this.props, {});
    }

    recheck = (props, prevProps) => {
        if (!isEqual(props.values, prevProps.values)) {
            this.targets && this.targets.abort();
            this.setState({sendTo: props.values.component ? 0 : null}, () => {
                let propsFilter = typeof props.values.filter === "string" ? JSON.parse(props.values.filter) : props.values.filter;
                if (props.values.component) {
                    let filter = null;
                    if (props.values.filter) {
                        filter = parseQuery(unparseQuery(propsFilter));
                        if (!removeEmpty(filter)) {
                            filter = null;
                        }
                    }
                    this.targets = sendRequest({
                        option: "componentlist",
                        component: props.values.component,
                        filter,
                        group: {by: "email"},
                        itemsperpage: 1,
                    }, {showError: false});
                    this.targets.then((response) => {
                        this.setState({
                            sendTo: parseInt(response.fullcount)
                        });
                    });
                }
            });
        }
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        this.recheck(this.props, prevProps);
    }

    render() {
        const filterProps = {
            name: "filter",
            value: typeof this.props.values.filter === "string" ? JSON.parse(this.props.values.filter) : this.props.values.filter,
            saveChanges: this.props.setFieldValue
        };
        let FilterComponent = null;
        switch (this.props.values.component) {
            case "OptInSubscriber":
                FilterComponent = OptInSubscriberFilter;
                break;
            case "User":
                FilterComponent = UserFilter;
                break;
        }
        const disabled = this.props.newsletterDisabled;
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <TextInput
                            name={this.props.componentConfig.idfield}
                            value={this.props.values[this.props.componentConfig.idfield]}
                            label="Kód"
                            role="idfield"
                            {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                        />
                    </div>
                    <div className="col-sm-8 col-sm-pull-4">
                        <Select
                            name="component"
                            storeType="local"
                            valueKey="key"
                            labelKey="label"
                            value={this.props.values.component}
                            saveChanges={this.props.setFieldValue}
                            autoSelect={true}
                            objectValue={false}
                            options={[
                                //{key: "user", label: "User"},
                                {key: "OptInSubscriber", label: "OptIn Feliratkozottak"},
                            ]}
                            label="Típus"
                            disabled={disabled || this.props.isLoading}
                        />
                    </div>
                </div>
                {FilterComponent && <Fragment>
                    <label className="control-labell">Feltétel</label>
                    <FilterComponent {...filterProps} disabled={disabled || this.props.isLoading} />
                </Fragment>}
                <div className="form-group">
                    <div className="form-control">
                        <b>{this.state.sendTo}</b> Feliratkozó van a feltételeknek megfelelően
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(NewsletterTargetForm);
